<template>
	<div class="home flex" >
			<side-menu />
			<div class="lg:pl-16 flex-grow w-full" >
				<NavBar title="Virtual Cashout" />
				<div class="py-8 px-12 text-left min-h-screen w-full">
					<div class="flex flex-wrap lg:flex-nowrap w-full space-x-4">
						<!-- left -->
						<div class="w-full lg:w-1/2 ">
							<p class="py-4 text-left w-96 dark:text-white">The virtual cashout functionality keeps track of when you have cashed out. The equity shown is based on the <strong>your</strong> simulated current equity. </p>
							<!--cashout -->
							<form>
								<div
									class="flex flex-col w-full max-w-lg items-stretch justify-between bg-white dark:bg-bs-dark-bg-over rounded-3xl tip-item p-3 xl:p-5 mt-4 "
								>	
									<div class="flex justify-between border-b border-gray-50 pb-4 mb-4">
										<h6 class="text-lg mb-2 whitespace-nowrap">Current Equity</h6>
									<h1 class="success-rate font-black ">{{formatCurrency(equity || 0)}}</h1>
									</div>
									<label
										class="text-base text-left block text-bs-gray-dark dark:text-white font-medium"
									>
										Cashout Equity
									</label>
									<div class="flex flex-wrap items-stretch w-full relative">
										<div class="flex -mr-px">
											<span
												class="flex items-center leading-normal bg-grey-lighter rounded-xl rounded-r-none border border-r-0 border-grey-light px-3 whitespace-no-wrap text-grey-dark text-sm dark:bg-bs-dark-bg dark:text-white dark:border-bs-blue-dark"
												>{{ currency }}</span
											>
										</div>
										<input
											v-model="cashoutEquity"
											type="number"
											step="1"
											min="1"
											:max="equity"
											class="flex-shrink flex-grow flex-auto leading-normal w-px border py-3 border-bs-dark-gray-light rounded-xl rounded-l-none px-3 relative focus:border-blue focus:shadow dark:bg-bs-dark-bg dark:text-white dark:border-bs-blue-dark"
											placeholder="Starting Equity"
										/>
									</div>
								</div>
							</form>
							<button class="block xl:inline-block text-white px-8 py-3 rounded hover:bg-bs-blue cursor-pointer transition-colors duration-300 btn-primary mt-4 cashout-btn" :disabled="!canCashout">Cash Out</button>
						</div>
						<!-- right -->
						<div class="w-full lg:w-1/2 ">
							<div class="flex flex-col w-full max-w-lg items-stretch justify-between bg-white dark:bg-bs-dark-bg-over rounded-3xl tip-item p-3 xl:p-5 mt-4 ">
								<div class="flex justify-start w-full items-center">
									<div class="w-16 h-16 rounded-full relative bg-bs-blue bg-opacity-10 flex items-center mr-4">
										<img src="@/assets/images/vault.svg" alt="Your vault" class="w-64 h-64 transform vault scale-110" />
									</div>
									<h1 class="success-rate font-black ">Your vault</h1	>
								</div>
								<div v-for="(v,i) in vault" :key="i" class="border-b border-gray-50 py-4">
									<h5 class="text-xs text-bs-gray">{{formatDate(v.date)}}</h5>
									<h2>{{formatCurrency(v.amount)}}</h2>
								</div>
							</div>
						</div>
					</div>
				
				</div>
			</div>
			<mob-menu class="lg:hidden" />
	</div>
</template>

<script>
import SideMenu from '@/components/organisms/SideMenu.vue'
import MobMenu from '@/components/organisms/MobMenu.vue'
import NavBar from "@/components/organisms/NavBar.vue"
import { mapGetters } from "vuex";
import {format} from "date-fns"
export default {
	name: "Support",
	components: {
		NavBar,
		SideMenu,
		MobMenu,
	},
	data: function(){
		return {
			cashoutEquity: 0,
			vault: [
				{
					date: new Date(),
					amount: 123456
				},
				{
					date: new Date(),
					amount: 300
				},
				{
					date: new Date(),
					amount: 2456
				}
			]
		}
	},
	computed: {
		...mapGetters(['equityByDate','settings']),
		currency: function(){
			return this?.settings?.currencyCode || 'EUR'
		},
		equity: function(){
			return  this.equityByDate[this.equityByDate.length - 1]?.y
		},
		canCashout: function(){
			return this.cashoutEquity > 0 && this.cashoutEquity <= this.equity
		}
	},
	mounted: function(){
		this.getData()
	},
	methods: {
		getData: async function(){
			await this.$store.dispatch('getHistory')
		},
		formatCurrency: function (n) {
			return (
				typeof n !== "undefined" &&
				n.toLocaleString('en-GB', {
					style: "currency",
					currency: this.currency,
					currencyDisplay: "symbol",
				})
			);
		},
		formatDate: function (str) {
			try {
				let d = new Date(str);
				if (d) {
					return format(d,'dd-MM-yyyy HH:mm');
				}
			} catch (e) {
				console.log(e);
			}
		}
	}
}
</script>

<style>
.cashout-btn:disabled {opacity:0.4;}

.vault {
	animation: float 4s ease-in-out infinite;
}
@keyframes float {
	0% {
		transform: translatey(0px) scale(1.04);
	}
	50% {
		transform: translatey(-2px)  scale(1.04);
	}
	100% {
		transform: translatey(0px)  scale(1.04);
	}
}
</style>